import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="sidebar"
export default class UserSidebarController extends Controller {
  static targets = [
    'sidebar',
    'sidebarTrigger',
  ];

  toggleSidebar() {
    this.sidebarTarget.classList.toggle('is-closed');
    this.sidebarTriggerTarget.setAttribute(
      'aria-expanded', this.sidebarTriggerTarget.getAttribute('aria-expanded') !== 'true'
    );
    document.querySelector('body').classList.toggle('has-closed-sidebar');
  }
}
